import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import Application from "./Application";
import Services from "./Services";
import Industry from "./Industry";
import Technologies from "./Technologies";
import Solutions from "./Solutions";
import Platforms from "./Platforms";
import Blog from "./Blog";
import Footer from "./Footer";
// import XeerTest from "./XeerTest";
import Transforming from "./Transforming";
import Innovation from "./Innovation";
import Achivement from "./Achivement";
import Pricing from "./Pricing";
import Features from "./Features";
import Testimonials from "./Testimonials";
import JoinWithUs from "./JoinWithUs";
import HowItsWork from "./HowItsWork";
import OnDemandSolutions from "./OnDemandSolutions";

function Index() {
  return (
    <>
      <div id="smooth-content" style={{ overflow: "clip" }}>
        <Header />
        {/* <XeerTest /> */}
        <Hero />
        <Transforming />
        {/* <Innovation /> */}
        <Application />
        <Achivement />
        <JoinWithUs />
        <Technologies />
        <OnDemandSolutions />
        <Features />
        {/* <Services /> */}
        <HowItsWork />
        <Testimonials />
        <Industry />
        {/* <Solutions /> */}
        <Pricing />
        <Platforms />
        <Blog />
      </div>
      <Footer />
    </>
  );
}

export default Index;
